<template>
  <div class="list-container">
    <div class="iconCenter-list">
      <div class="iconCenter-item" v-for="(item, idx) in list" :key="idx">
        <div class="item-main">
          <div class="item-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="item-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
